export default "__VITE_ASSET__3c9EhMwx__"